/*(function () {
  const slideshowSecondSection = () => {
    const section = document.querySelector('.section-template--20196391715069__slideshow_YPah4R');
    if (!section) return;

    const swiperImgWrapper = section.querySelector('.slideshow__contents-wrapper');
    if (!swiperImgWrapper) return;

    const checkSwiper = setInterval(() => {
      const swiperImg = swiperImgWrapper.swiper;
      if (!swiperImg || !swiperImg.initialized) return;

      clearInterval(checkSwiper);
      

      const slides = section.querySelectorAll('.slideshow__content.swiper-slide');
      const tabs = section.querySelectorAll('.slideshow__tab.swiper-slide');
      const mobileTabs = section.querySelectorAll('.slideshow__tab--mob');
      const desktopTabs = section.querySelector('.slideshow__tabs-wrapper');

      // Gestione visibilità tab desktop / mobile
      const forceTabsVisibility = () => {
        setTimeout(() => {
          if (window.innerWidth >= 1101) {
            desktopTabs?.setAttribute("style", "display: flex !important;");
            mobileTabs.forEach(tab => tab.setAttribute("style", "display: none !important;"));
          } else {
            desktopTabs?.setAttribute("style", "display: none !important;");
            mobileTabs.forEach(tab => tab.setAttribute("style", "display: block !important;"));
          }
        }, 300);
      };

      forceTabsVisibility();

      // Funzione aggiornata per posizionare il blocco info
      const updateInfoPosition = () => {
        const slides = section.querySelectorAll('.slideshow__content');
        const tabs = section.querySelectorAll('.slideshow__tab');
        const activeIndex = swiperImg.realIndex;

        slides.forEach(slide => {
          const info = slide.querySelector('.slideshow__info--wrapper');
          if (!info) return;

          // Indice reale anche se la slide è duplicata dal loop
          const slideIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
          const tab = tabs[slideIndex];

          if (slideIndex === activeIndex) {
            info.style.display = 'block';

            if (tab) {
              const tabRect = tab.getBoundingClientRect();
              const sectionRect = section.getBoundingClientRect();

              info.style.position = 'absolute';
              info.style.top = `${tabRect.bottom - sectionRect.top + 8}px`;
              info.style.left = `${tab.offsetLeft}px`;
              info.style.width = `${tab.offsetWidth}px`;
            }
          } else {
            info.style.display = 'none';
          }
        });
      };

      // Debounce per il resize (evita chiamate continue)
      let resizeTimeout;
      const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          forceTabsVisibility();
          updateInfoPosition();
        }, 300);
      };

      // iniziale
      updateInfoPosition();

      // listener
      swiperImg.on('slideChangeTransitionEnd', updateInfoPosition);
      window.addEventListener('resize', handleResize);

    }, 200);
  };

  document.addEventListener('DOMContentLoaded', slideshowSecondSection);
  document.addEventListener('shopify:section:load', slideshowSecondSection);
})();
*/







/* READ MORE - READ LESS 
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".collection-description__wrapper").forEach(wrapper => {
    const content = wrapper.querySelector(".collection-description__content");
    const toggle = wrapper.querySelector(".collection-description__toggle");
    const charLimit = parseInt(wrapper.dataset.characterLimit, 10);

    if (!content || !toggle) return;

    // Controlla la lunghezza senza HTML
    const plainText = content.textContent.trim();

    if (plainText.length > charLimit) {
      toggle.hidden = false;

      toggle.addEventListener("click", () => {
        const expanded = wrapper.classList.toggle("expanded");
        toggle.setAttribute("aria-expanded", expanded);

        toggle.textContent = expanded
          ? toggle.closest(".collection-description-readmore")
                  .dataset.readLessLabel || "Leggi di meno"
          : toggle.closest(".collection-description-readmore")
                  .dataset.readMoreLabel || "Leggi di più";
      });
    }
  });
});
*/


document.addEventListener('DOMContentLoaded', () => {
  //READ MORE - READ LESS
  const readmoreSections = document.querySelectorAll('.readmore-wrapper');

  readmoreSections.forEach(wrapper => {
    const content = wrapper.querySelector('.readmore-content');
    const button = wrapper.querySelector('.readmore-toggle');
    const collapsedHeight = 180; // Altezza visibile iniziale in px

    if (!content || !button) return;

    // Mostra il bottone solo se il testo è lungo
    if (content.scrollHeight > collapsedHeight) {
      content.style.maxHeight = collapsedHeight + 'px';
      button.addEventListener('click', () => {
        const expanded = wrapper.classList.toggle('expanded');
        content.style.maxHeight = expanded ? content.scrollHeight + 'px' : collapsedHeight + 'px';
        button.textContent = expanded ? 'Read Less' : 'Read More';
      });
    } else {
      button.style.display = 'none';
    }
  });


  /* VARIANTI PRODOTTO */
  (function () {
  'use strict';

  //verifica se un’opzione (radio, label, bottone, ecc.) è disabilitata
  function isOptionDisabled(inputOrLabel) {
    if (!inputOrLabel) return true;
    if (inputOrLabel.disabled) return true;
    if (inputOrLabel.classList && inputOrLabel.classList.contains('disabled')) return true;
    if (inputOrLabel.closest && inputOrLabel.closest('.disabled')) return true;
    return false;
  }

  //non legare due volte lo stesso variant-radios - dataset.autoSelectBound = flag personalizzato
  function bindPicker(picker) {
    if (!picker || picker.dataset.autoSelectBound === 'true') return;
    picker.dataset.autoSelectBound = 'true';
    console.log('[auto-select] binding picker:', picker.id || picker);

    // attende che ci siano almeno due fieldset nel componente
    const waitForFieldsets = new Promise((resolve) => {
      const fs = picker.querySelectorAll('fieldset');
      if (fs && fs.length >= 2) return resolve(fs);

      // osserva modifiche fino a quando non compaiono fieldset
      const mo = new MutationObserver((mutations, obs) => {
        const newFs = picker.querySelectorAll('fieldset');
        if (newFs && newFs.length >= 2) {
          obs.disconnect();
          resolve(newFs);
        }
      });
      mo.observe(picker, { childList: true, subtree: true });
      // fallback timeout 2000ms
      setTimeout(() => resolve(picker.querySelectorAll('fieldset')), 2000);
    });

    waitForFieldsets.then((fieldsets) => {
      const fsets = Array.from(fieldsets);
      if (fsets.length < 2) {
        console.warn('[auto-select] no enough fieldsets found in picker', picker);
        return;
      }

      //fieldset disponibili
      const firstGroup = fsets[0];
      const secondGroup = fsets[1];

      //selezionare il primo elemento disponibile del secondo gruppo, quando la trova, la seleziona e genera evento change per far reagire Shopify
      function pickFirstAvailableWeight() {
        // cerca input radio nel secondo gruppo
        // tieni conto di radios, select, o pulsanti dentro li/label
        const radios = Array.from(secondGroup.querySelectorAll('input[type="radio"]'));
        const selects = Array.from(secondGroup.querySelectorAll('select'));
        const buttons = Array.from(secondGroup.querySelectorAll('button, li, [role="option"], label'));

        // prefer radios
        if (radios.length) {
          const firstAvailable = radios.find(r => !isOptionDisabled(r));
          if (firstAvailable) {
            if (!firstAvailable.checked) {
              firstAvailable.checked = true;
              firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
              console.log('[auto-select] radio selected:', firstAvailable.id || firstAvailable.value, 'in', secondGroup);
            } else {
              console.log('[auto-select] radio already selected:', firstAvailable.id || firstAvailable.value);
            }
            return;
          }
        }

        // fallback select
        if (selects.length) {
          const sel = selects[0];
          const opt = Array.from(sel.options).find(o => !o.disabled);
          if (opt) {
            sel.value = opt.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            console.log('[auto-select] select option chosen:', opt.value);
            return;
          }
        }

        // fallback button-like elements
        if (buttons.length) {
          const firstAvailableBtn = buttons.find(b => !isOptionDisabled(b));
          if (firstAvailableBtn) {
            try {
              firstAvailableBtn.click();
              console.log('[auto-select] clicked button/label fallback:', firstAvailableBtn);
            } catch (e) {
              console.warn('[auto-select] fallback click failed', e);
            }
          } else {
            console.warn('[auto-select] no available button/label found in secondGroup');
          }
          return;
        }

        console.warn('[auto-select] no options found to auto-select in secondGroup', secondGroup);
      }

      // handler per change/click sul primo gruppo
      const handler = (ev) => {
        // solo se l'evento arriva da input/label del primoGroup
        // la chiamata è sempre: seleziona il primo disponibile del secondoGroup
        setTimeout(() => { // piccolo delay per dare tempo al tema ad aggiornare eventuali disabled
          pickFirstAvailableWeight();
        }, 120);
      };

      // bind a fieldset itself (cattura events delegati) e a inputs diretti
      firstGroup.addEventListener('change', handler, { passive: true });
      firstGroup.addEventListener('click', handler, { passive: true });
      Array.from(firstGroup.querySelectorAll('input, label, button, [role="option"]')).forEach(el => {
        el.addEventListener('change', handler, { passive: true });
        el.addEventListener('click', handler, { passive: true });
      });

      // run once now to match initial page load behavior
      setTimeout(() => pickFirstAvailableWeight(), 120);
    });
  }

  // iniziale: tenta di bindare pickers già nel DOM
  Array.from(document.querySelectorAll('variant-radios')).forEach(bindPicker);

  // MutationObserver globale per nuovi pickers (es. AJAX, section load)
  const globalMo = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (!node) return;
        if (node.nodeType !== 1) return;
        if (node.tagName && node.tagName.toLowerCase() === 'variant-radios') {
          bindPicker(node);
        } else {
          // se è un contenitore che potrebbe contenere variant-radios
          const nested = node.querySelector && node.querySelector('variant-radios');
          if (nested) bindPicker(nested);
        }
      });
    });
  });
  globalMo.observe(document.body, { childList: true, subtree: true });

  // anche bind manuale su eventi shopify di reload/section
  ['shopify:section:load','shopify:section:reorder','shopify:section:select'].forEach(ev => {
    document.addEventListener(ev, () => {
      Array.from(document.querySelectorAll('variant-radios')).forEach(bindPicker);
    });
  });

  
  

  })();


  /* FINE VARIANTI */

  /* SLIDER ANNOUNCEMENT BAR */
    const slider = document.querySelector(".announcement-slider");
  const slides = document.querySelectorAll(".announcement-slide");
  if (!slides.length) return;

  let index = 0;
  const intervalTime = 4000;

  // Avvolgi tutte le slide in un container interno per animarle insieme
  const inner = document.createElement("div");
  inner.classList.add("announcement-slider-inner");

  // Sposta le slide nel contenitore interno
  slides.forEach(slide => inner.appendChild(slide));
  slider.appendChild(inner);

  function showSlide(i) {
    const offset = -i * 100; // sposta di 100% per ogni slide
    inner.style.transform = `translateX(${offset}%)`;
  }

  showSlide(index);
  setInterval(() => {
    index = (index + 1) % slides.length;
    showSlide(index);
  }, intervalTime);

  
});







